import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { range, formatRawDate } from '../utils/helpers';
import Step from './shared/Step';
import { LocalesContext, SettingsContext } from '../index';
import {
  setSport,
  setBoarding,
  setCamperField,
  setBusinessType,
  setIsposition,
  setIsSecondaryPosition,
} from '../reducers/form';
import API from '../utils/api';
import GTMService, { TYPES } from '../utils/gtm';

const api = new API();
const gtm = new GTMService();

// XXX Avoid creating dates with new Date('yyyy-mm-dd') it causes
// issues with timezones

function daysInMonth(year, month) {
  const date = new Date(year, month + 1, 0);
  return date.getDate();
}

function getBirthdate(age) {
  const d = new Date();
  d.setFullYear(d.getFullYear() - age);
  return d;
}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const StepOne = ({
  initialBoarding,
  initialAge,
  initialGender,
  initialBirthdate,
  sport,
  businessType,
  boarding,
  age,
  gender,
  position,
  secondaryPosition,
  secondaryPositions,
  setSport,
  setBusinessType,
  setBoarding,
  setCamperField,
  locked,
  isposition,
  setIsposition,
  setIsSecondaryPosition,
}) => {
  const locales = useContext(LocalesContext);
  const settings = useContext(SettingsContext);
  console.log('settings:', settings);
  console.log('sport 1:', sport);
  if(settings.sport){
    //setSport(settings.sport);
    sport = settings.sport;
  }
  if(settings.position){
    position = settings.position;
    setCamperField('position', settings.position);
    console.log('Set position', settings.position);
  }
  if(settings.secondaryPosition){
    setCamperField('secondaryPositionName', settings.secondaryPosition);
    console.log('Set secondaryPositionName', settings.secondaryPosition);
  }
  console.log('sport 2:', sport);
  const parts = settings.initialBirthdate ? settings.initialBirthdate.split('-') : null;
  //const parts = initialBirthdate ? initialBirthdate.split('-') : null;
  const [day, setDay] = useState(parts ? Number(parts[2]) : 0);
  const [month, setMonth] = useState(parts ? Number(parts[1]) - 1 : -1);
  const [year, setYear] = useState(parts ? Number(parts[0]) : 0);
  const [ageRange, setAgeRange] = useState([]);
  const [hideBoardingField, setHideBoardingField] = useState(false);
  const [hideBusinessTypeField, setHideBusinessTypeField] = useState(false);
  const [hideGenderField, setHideGenderField] = useState(false);
  const [positions, setPositions] = useState([]);
  //const [mainPosition, setMainPosition] = useState('Default');
  //console.log('mainPosition',mainPosition);

  const [availableSports, setAvailableSports] = useState([]);

  // Setup from settings
  useEffect(() => {
    if (
      settings.boarding === 'Boarding' ||
      settings.boarding === 'Non-Boarding'
    ) {
      setHideBoardingField(true);
      setBoarding(settings.boarding === 'Boarding');
    }

    if (settings.gender === 'Male' || settings.gender === 'Female') {
      setHideGenderField(true);
      setCamperField('gender', settings.gender);
    }

    if(settings.businessType) {
      setBusinessType(settings.businessType);
      setHideBusinessTypeField(true);
    }

  }, [settings.boarding, settings.gender, settings.businessType, setBoarding, setCamperField, setBusinessType]);

  // Setup initial form state from retargeting data
  useEffect(() => {
    if (initialBoarding === 'Boarding' || initialBoarding === 'Non-Boarding') {
      setBoarding(initialBoarding === 'Boarding');
    }
  }, [initialBoarding, setBoarding]);

  useEffect(() => {
    if (!initialAge) {
      return;
    }

    const date = getBirthdate(Number(initialAge));
    setYear(date.getFullYear());
    setMonth(date.getMonth());
    setDay(date.getDate());
  }, [initialAge]);

  useEffect(() => {
    if (initialGender === 'Male' || initialGender === 'Female') {
      setCamperField('gender', initialGender);
    }
  }, [initialGender, setCamperField]);

  // Load required data
  useEffect(() => {
    // In case the app is initialized via HTML attrs
    if (settings.sport) {
      api
        .fetchHistogram({
          group_by: 'age_from,age_to,boarding,position_name',
          business_type: businessType,
          sport: settings.sport,
        })
        .then((res) => {
          if (!res) {
            return;
          }

          console.log('fetchHistogram:', res);

          // Setting boarding field
          if (res.results.boarding && res.results.boarding.length === 1) {
            setBoarding(res.results.boarding[0].name === 'Boarding');
            setHideBoardingField(true);
          }

          // Setting gender options
          if (res.results.gender && res.results.gender.length === 1) {
            setCamperField('gender', res.results.gender[0].name);
            setHideGenderField(true);
          }

          const date = new Date();
          const currentYear = date.getFullYear();
          setAgeRange([
            currentYear - Math.max(...res.results.age_to.map((a) => a.name)),
            currentYear - Math.min(...res.results.age_from.map((a) => a.name)),
          ]);

          setPositions(res.results.position_name);
          if (res.results.position_name.length === 0) {
            setCamperField('position', 'Default');
          }
        });
      // Need to fetch available sports and display them
    } else if(businessType && day === 0 && month === -1 && year === 0) {
        api
        .fetchHistogram({
          group_by: 'age_from,age_to',
          business_type: businessType,
          product_type: 'Camp'
        })
        .then((res) => {
          console.log('fetchHistogram by businessType:', res);
          if (!res) {
            return;
          }

          const date = new Date();
          const currentYear = date.getFullYear();
          setAgeRange([
            currentYear - Math.max(...res.results.age_to.map((a) => a.name)),
            currentYear - Math.min(...res.results.age_from.map((a) => a.name)),
          ]);

        });
    } else if(businessType && day > 0 && month > -1 && year > 0 && !gender) {
        api
        .fetchHistogram({
          group_by: 'age_from,age_to,boarding,position_name,sport',
          business_type: businessType,
          age: age,
          product_type: 'Camp'
        })
        .then((res) => {
          console.log('fetchHistogram by businessType, age:', res);
          if (!res) {
            return;
          }

          // Setting sport field
          if (res.results.sport && res.results.sport.length === 1) {
            setAvailableSports(res.results.sport);
          }

          // Setting boarding field
          if (res.results.boarding && res.results.boarding.length === 1) {
            setBoarding(res.results.boarding[0].name === 'Boarding');
            setHideBoardingField(true);
          }

          // Setting gender options
          if (res.results.gender && res.results.gender.length === 1) {
            setCamperField('gender', res.results.gender[0].name);
            setHideGenderField(true);
          }

          //setPositions(res.results.position_name);
          if (res.results.position_name.length === 0) {
            setCamperField('position', 'Default');
          }

          const date = new Date();
          const currentYear = date.getFullYear();
          setAgeRange([
            currentYear - Math.max(...res.results.age_to.map((a) => a.name)),
            currentYear - Math.min(...res.results.age_from.map((a) => a.name)),
          ]);

        });
      } else if(businessType && day > 0 && month > -1 && year > 0 && gender) {
        api
        .fetchHistogram({
          group_by: 'age_from,age_to,boarding,position_name,sport',
          business_type: businessType,
          age: age,
          gender: gender,
          product_type: 'Camp'
        })
        .then((res) => {
          console.log('fetchHistogram by businessType, age, gender:', res);
          if (!res) {
            return;
          }

          // Setting sport field
          if (res.results.sport && res.results.sport.length) {
            setAvailableSports(res.results.sport);
            console.log('fetchHistogram setAvailableSports:', res.results.sport);
          }

          // Setting boarding field
          if (res.results.boarding && res.results.boarding.length === 1) {
            setBoarding(res.results.boarding[0].name === 'Boarding');
            setHideBoardingField(true);
          }

          //setPositions(res.results.position_name);
          if (res.results.position_name.length === 0) {
            setCamperField('position', 'Default');
          }

          const date = new Date();
          const currentYear = date.getFullYear();
          setAgeRange([
            currentYear - Math.max(...res.results.age_to.map((a) => a.name)),
            currentYear - Math.min(...res.results.age_from.map((a) => a.name)),
          ]);

        });
    }
  }, [setBoarding, setCamperField, businessType, settings.sport, day, month, year, age, gender]);

  // Load required data when sport changed in this step
  useEffect(() => {
    if (!sport) {
      return;
    }

    // When this property is changed by the user
    api
      .fetchHistogram({
        group_by: 'boarding,position_name,business_type',
        age,
        gender,
        sport,
      })
      .then((res) => {
        console.log('fetchHistogram by age, gender, sport:', res);
        if (!res) {
          return;
        }

        // Setting boarding field
        if (res.results.boarding && res.results.boarding.length === 1) {
          setBoarding(res.results.boarding[0].name === 'Boarding');
          setHideBoardingField(true);
        }

        setPositions(res.results.position_name);
        if (res.results.position_name.length === 0) {
          setCamperField('position', 'Default');
        }
      });
  }, [sport, gender, age, setBoarding, setCamperField, setBusinessType]);

  useEffect(() => {
    if (day > 0 && month > -1 && year > 0) {
      if (daysInMonth(year, month) < day) {
        setCamperField('birthdate', null);
        return;
      }

      const newDate = new Date(year, month, day);
      setCamperField('birthdate', formatRawDate(newDate));
    }
  }, [day, month, year, setCamperField]);

  useEffect(() => {
    if (typeof boarding !== 'boolean') {
      return;
    }

    gtm.trackChange(TYPES.OR_CAMPER_BOARDING);
  }, [boarding]);

  if(availableSports){
      //console.log('availableSports 1:', availableSports);
      availableSports.sort((a, b) => a.name.localeCompare(b.name));
      //console.log('availableSports 2:', availableSports);
  }

  const sportSelector = (
    <div className="field select">
      <h4 className="field__title">Choose sport</h4>

      <div className="aligner-xxs-left">
        <label
          className={classNames('field__label select', {
            'field__input--selected': !!sport,
          })}
        >
          <select
            name="sport"
            className="field__select"
            required
            value={sport}
            onChange={(event) => {
              if (event.target.value !== "-1") {
                //setBoarding(null);
                setCamperField('position', 'Default');
                setCamperField('mainPosition', 'Default');
                setCamperField('secondaryPosition', '');
                setCamperField('secondaryPositionName', '');
                setSport(event.target.value);
              }
            }}
          >
            <option value="-1">Sport</option>

            {availableSports.map((as, i) => (
              <option
                key={`${as.name}-${i}`}
                value={as.name}
                className={classNames('field__option', {
                  'field__option--selected': as.name === sport,
                })}
              >
                {as.name}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );

  const genderSelector = (
    <div
      className={classNames('field', {
        'field--hidden': hideGenderField,
      })}
    >
      <h4 className="field__title">Camper gender</h4>
      <label
        className={classNames('field__label', {
          'field__input--selected': gender === 'Female',
        })}
      >
        Female
        <input
          type="radio"
          name="gender"
          value="Female"
          className="field__input"
          checked={gender === 'Female'}
          onChange={() => {
            setSport(null);
            setCamperField('position', 'Default');
            //setCamperField('secondaryPosition', null);
            setCamperField('gender', 'Female');
          }}
        />
      </label>
      <label
        className={classNames('field__label', {
          'field__input--selected': gender === 'Male',
        })}
      >
        Male
        <input
          type="radio"
          name="gender"
          value="Male"
          className="field__input"
          checked={gender === 'Male'}
          required
          onChange={() => {
            setSport(null);
            setCamperField('position', 'Default');
            //setCamperField('secondaryPosition', null);
            setCamperField('gender', 'Male');
          }}
        />
      </label>
    </div>
  );

  const ageSelector = (
    <div className="field select">
      <h4 className="field__title">Camper date of birth</h4>
      <div className="aligner-xxs-left">
        <label
          className={classNames('field__label select', {
            'field__input--selected': typeof month === 'number' && month > -1,
          })}
        >
          <select
            name="birthdate"
            className="field__select"
            required
            value={month}
            onChange={(event) => {
              if (event.target.value === '-1') {
                setCamperField('birthdate', null);
              }

              setMonth(Number(event.target.value));
            }}
          >
            <option value="-1">MM</option>

            {MONTHS.map((m, i) => (
              <option
                key={`${m}-${i}`}
                value={i}
                className={classNames('field__option', {
                  'field__option--selected': month === i,
                })}
              >
                {m}
              </option>
            ))}
          </select>
        </label>
        <span> / </span>
        <label
          className={classNames('field__label select', {
            'field__input--selected': typeof day === 'number' && day > 0,
          })}
        >
          <select
            name="birthdate"
            className="field__select"
            required
            value={day}
            onChange={(event) => {
              if (event.target.value === '0') {
                setCamperField('birthdate', null);
              }

              setDay(Number(event.target.value));
            }}
          >
            <option value="0">DD</option>
            {range(1, daysInMonth(year, month), 1).map((v, i) => (
              <option
                key={`${v}-${i}`}
                value={v}
                className={classNames('field__option', {
                  'field__option--selected': day === v,
                })}
              >
                {v}
              </option>
            ))}
          </select>
        </label>
        <span> / </span>
        <label
          className={classNames('field__label select', {
            'field__input--selected': typeof year === 'number' && year > 0,
          })}
        >
          <select
            name="birthdate"
            className="field__select"
            required
            value={year}
            onChange={(event) => {
              if (event.target.value === '0') {
                setCamperField('birthdate', null);
              }
              //setCamperField('gender', null);
              //setSport(null);
              //setBoarding(null);
              //setCamperField('position', 'Default');
              //setCamperField('secondaryPosition', null);
              setYear(Number(event.target.value));
              if(settings.sport === undefined && settings.gender === undefined){
                setCamperField('gender', null);
                setSport(null);
              }
            }}
          >
            <option value="0">YYYY</option>
            {range(ageRange[0], ageRange[1], 1).map((v, i) => (
              <option
                key={`${v}-${i}`}
                value={v}
                className={classNames('field__option', {
                  'field__option--selected': year === v,
                })}
              >
                {v}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );

  const boardingSelector = (
    <div
      className={classNames('field', {
        'field--hidden': hideBoardingField,
      })}
    >
      <h4 className="field__title">
        {businessType === 'Adult Program'
          ? 'Stay at the Legacy Hotel at IMG Academy'
          : 'Housing'}
      </h4>
      <label
        className={classNames('field__label', {
          'field__input--selected': !!boarding,
        })}
      >
        {businessType === 'Adult Program' ? 'Yes' : 'Boarding'}
        <input
          type="radio"
          name="boarding"
          className={classNames('field__input', {
            'field__input--selected': !!boarding,
          })}
          required
          checked={!!boarding}
          onChange={() => {
            setCamperField('position', 'Default');
            //setCamperField('secondaryPosition', null);
            setBoarding(true);
          }}
        />
      </label>
      <label
        className={classNames('field__label', {
          'field__input--selected': boarding === false,
        })}
      >
        {settings.businessType === 'Adult Program' ? 'No' : 'Non-Boarding'}
        <input
          type="radio"
          name="boarding"
          className={classNames('field__input', {
            'field__input--selected': boarding === false,
          })}
          required
          checked={boarding === false}
          onChange={() => {
            setCamperField('position', 'Default');
            //setCamperField('secondaryPosition', null);
            setBoarding(false);
          }}
        />
      </label>
    </div>
  );

  const businessTypeSelector = (
    <div
      className={classNames('field', {
        'field--hidden': hideBusinessTypeField,
      })}
    >
      <h4 className="field__title">Interested in</h4>
      <label
        className={classNames('field__label', {
          'field__input--selected': businessType === 'Youth Camp',
        })}
      >
        Sport camps
        <input
          type="radio"
          name="businessType"
          value="Youth Camp"
          className="field__input"
          checked={businessType === 'Youth Camp'}
          onChange={() => {
            setDay(0);
            setMonth(-1);
            setYear(0);
            setSport(null);
            setCamperField('gender', null);
            setBusinessType('Youth Camp');
          }}
        />
      </label>
      <label
        className={classNames('field__label', {
          'field__input--selected': businessType === 'Adult Program',
        })}
      >
        Adult Sport Camps
        <input
          type="radio"
          name="businessType"
          value="Adult Program"
          className="field__input"
          checked={businessType === 'Adult Program'}
          required
          onChange={() => {
            setDay(0);
            setMonth(-1);
            setYear(0);
            setSport(null);
            setCamperField('gender', null);
            setBusinessType('Adult Program');
          }}
        />
      </label>
    </div>
  );

  console.log('businessType:', businessType);
  console.log('day month year:', day, month, year);
  console.log('sport:', sport);
  console.log('positions:', positions);
  console.log('secondaryPositions:', secondaryPositions);

  console.log('position:', position);
  console.log('secondaryPositionName:', secondaryPosition);

  console.log('locked1:', locked);

  setIsposition(false);
  setIsSecondaryPosition(false);
  if(sport && positions.length > 0){
    setIsposition(true);
  }
  if(sport && secondaryPositions.length > 0){
    setIsSecondaryPosition(true);
  }

  console.log('isposition:', isposition);

  if(!businessType) {
    return (
      <Step title="Step 1" subtitle={locales.choose_options_title}>
        <form className="step1-form-wrapper" onSubmit={(e) => e.preventDefault()}>
          {locked &&
            <div class="locked"></div>
          }
          {businessTypeSelector}
        </form>
      </Step>
    );
  } else if(day===0 || month===-1 || year===0) {
    return (
      <Step title="Step 1" subtitle={locales.choose_options_title}>
        <form className="step1-form-wrapper" onSubmit={(e) => e.preventDefault()}>
          {locked &&
            <div class="locked"></div>
          }
          {businessTypeSelector}

          {ageSelector}
        </form>
      </Step>
    );
  } else if(!gender) {
    return (
      <Step title="Step 1" subtitle={locales.choose_options_title}>
        <form className="step1-form-wrapper" onSubmit={(e) => e.preventDefault()}>
          {locked &&
            <div class="locked"></div>
          }
          {businessTypeSelector}

          {ageSelector}

          {genderSelector}
        </form>
      </Step>
    );
  } else {
    return (
      <Step title="Step 1" subtitle={locales.choose_options_title}>
        <form className="step1-form-wrapper" onSubmit={(e) => e.preventDefault()}>
          {locked &&
            <div class="locked"></div>
          }
          {!settings.businessType && businessTypeSelector}

          {ageSelector}

          {genderSelector}

          {!settings.sport && sportSelector}

          {sport && boardingSelector}

          {sport && positions.length > 0 && (
            <div className="field select">
              <h4 className="field__title">Position</h4>
              <label
                className={classNames('field__label select', {
                  'field__input--selected': !!position,
                })}
              >
                <select
                  name="position"
                  className="field__select"
                  required
                  value={position || ''}
                  onChange={(event) => {
                    if (event.target.value === '-1') {
                      setCamperField('position', null);
                    } else {
                      setCamperField('position', event.target.value);
                    }
                    //setMainPosition(event.target.value);
                    setCamperField('mainPosition', event.target.value);
                  }}
                >
                  <option value="-1">Select camper position</option>

                  {positions.map((p, i) => (
                    <option
                      key={`${p.name}-${i}`}
                      value={p.name}
                      className={classNames('field__option', {
                        'field__option--selected': position === p.name,
                      })}
                    >
                      {p.name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          )}

          {sport && secondaryPositions.length > 0 && (
            <div className="field select">
              {positions.length === 0 && (
                <h4 className="field__title">Position</h4>
              )}
              {positions.length > 0 && (
                <h4 className="field__title">Secondary position</h4>
              )}
              <label
                className={classNames('field__label select', {
                  'field__input--selected': secondaryPosition !== '',
                })}
              >
                <select
                  type="text"
                  name="position"
                  className="field__select"
                  value={secondaryPosition}
                  required
                  onChange={(e) => {
                    setCamperField('secondaryPosition', e.target.value);
                    const p = secondaryPositions.find(
                      (p) => p.PositionId === e.target.value
                    );
                    setCamperField('secondaryPositionName', p ? p.Name : '');
                    //setMainPosition(e.target.value);
                    //setCamperField('mainPosition', p ? p.Name : e.target.value);
                  }}
                >
                  <option value="Default">Select Position</option>
                  {secondaryPositions.map((p) => (
                    <option key={p.PositionId} value={p.PositionId}>
                      {p.Name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          )}
        </form>
      </Step>
    );
  }


};

const mapStateToProps = (state) => ({
  sport: state.form.sport,
  boarding: state.form.boarding,
  age: Number(state.form.camper.age),
  gender: state.form.camper.gender,
  businessType: state.form.businessType,
  position: state.form.camper.position,
  secondaryPosition: state.form.camper.secondaryPosition,
  locked: state.form.locked,
  isposition: state.form.isposition,
});

const mapDispatchToProps = (dispatch) => ({
  setSport: (value) => dispatch(setSport(value)),
  setBoarding: (value) => dispatch(setBoarding(value)),
  setBusinessType: (value) => dispatch(setBusinessType(value)),
  setCamperField: (key, value) => dispatch(setCamperField(key, value)),
  setIsposition: (value) => dispatch(setIsposition(value)),
  setIsSecondaryPosition: (value) => dispatch(setIsSecondaryPosition(value)),
});

StepOne.propTypes = {
  sport: PropTypes.string,
  boarding: PropTypes.bool,
  age: PropTypes.number,
  gender: PropTypes.string,
  businessType: PropTypes.string,
  secondaryPositions: PropTypes.array,
  setSport: PropTypes.func.isRequired,
  setBoarding: PropTypes.func.isRequired,
  setBusinessType: PropTypes.func.isRequired,
  setCamperField: PropTypes.func.isRequired,
  locked: PropTypes.bool,
  isposition: PropTypes.isposition,
  setIsposition: PropTypes.func.isRequired,
  setIsSecondaryPosition: PropTypes.func.isRequired,
};

StepOne.displayName = 'StepOne';

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
